import HealthCare from "./HealthCare"

export default HealthCare
